export const PET_TYPES = {
  DOGS: 'dogs',
  CATS: 'cats',
};

// Endpoints base del backend
export const API_BASE = {
  DOGS: '/dogs',
  CATS: '/cats',
};

export const DEFAULT_PAGE_SIZE = 10;
export const MAX_PAGE_SIZE = 50;

